import { Card, SubTitle } from "components/atoms";
import { Template } from "components/modecules";

export default function SuccessPage() {
  return (
    <Template>
      <Card className="m-auto flex flex-col justify-center mt-10">
        <h2 className="font-tt-ramillas-trl-bold text-center text-[25px] text-fourth uppercase mt-8 mb-5">
          Votre réponse a été enregistrée.
        </h2>
        <p className="text-center mt-5 font-tt-ramillas-trl-variable-roman">
          Merci d'avoir participé !
        </p>
      </Card>
    </Template>
  );
}
